// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"130":"3f8f7cad","289":"26ffaa0d"}[chunkId] + ".chunk.css";
};